
const marketRouter = {
  path: '/',
  component: () => import('@/components/report/home.vue'),
  children: [
    //客户消费分析
    {
      path: '/report/cust_indicator_summary',
      name: 'cust_indicator_summary',
      component: resolve => require(['@/components/report/customerConsumption/indicatorSummary/index.vue'], resolve)
    },
    {
      path: '/report/cust_consumption_overview',
      name: 'cust_consumption_overview',
      component: resolve => require(['@/components/report/customerConsumption/overview/index.vue'], resolve)
    },
    {
      path: '/report/cust_consumption_trends',
      name: 'cust_consumption_trends',
      component: resolve => require(['@/components/report/customerConsumption/trends/index.vue'], resolve)
    },
    {
      path: '/report/cust_consumption_growth',
      name: 'cust_consumption_growth',
      component: resolve => require(['@/components/report/customerConsumption/growth/index.vue'], resolve)
    },
    {
      path: '/report/cust_retention_analysis',
      name: 'cust_retention_analysis',
      component: resolve => require(['@/components/report/customerConsumption/retentionAnalysis/index.vue'], resolve)
    },
    {
      path: '/report/cust_loyalty',
      name: 'cust_loyalty',
      component: resolve => require(['@/components/report/customerConsumption/loyalty/index.vue'], resolve)
    },
    {
      path: '/report/cust_lifecycle',
      name: 'cust_lifecycle',
      component: resolve => require(['@/components/report/customerConsumption/lifecycle/index.vue'], resolve)
    },
    // 会员分析
    {
      path: '/report/cust_index',
      name: 'cust_index',
      component: resolve => require(['@/components/report/customer/index/survery.vue'], resolve)
    },
    {
      path: '/report/cust_target_trend',
      name: 'cust_target_trend',
      component: resolve => require(['@/components/report/customer/trend/index.vue'], resolve)
    },
    {
      path: '/report/cust_target',
      name: 'cust_target',
      component: resolve => require(['@/components/report/customer/target/cust_target.vue'], resolve)
    },
    {
      path: '/report/cust_save',
      name: 'cust_save',
      component: resolve => require(['@/components/report/customer/save/index.vue'], resolve)
    },
    {
      path: '/report/cust_faith',
      name: 'cust_faith',
      component: resolve => require(['@/components/report/customer/faith/index.vue'], resolve)
    },
    {
      path: '/report/cust_newMembers',
      name: 'cust_newMembers',
      component: resolve => require(['@/components/report/customer/new_members/index.vue'], resolve)
    },
    {
      path: '/report/cust_Members',
      name: 'cust_Members',
      component: resolve => require(['@/components/report/customer/members/index.vue'], resolve)
    },
    // 活动分析
    {
      path: '/report/activity_index',
      name: 'activity_index',
      component: resolve => require(['@/components/report/activity/index/index.vue'], resolve)
    },
    {
      path: '/report/activity_target_trend',
      name: 'activity_target_trend',
      component: resolve => require(['@/components/report/activity/trend/index.vue'], resolve)
    },
    {
      path: '/report/activity_detail',
      name: 'activity_detail',
      component: resolve => require(['@/components/report/activity/detail/index.vue'], resolve)
    },
    {
      path: '/report/activity_change',
      name: 'activity_change',
      component: resolve => require(['@/components/report/activity/change/index.vue'], resolve)
    },
    {
      path: '/report/activity_save',
      name: 'activity_save',
      component: resolve => require(['@/components/report/activity/save/index.vue'], resolve)
    },
    // 优惠券分析
    {
      path: '/report/coupons_index',
      name: 'coupons_index',
      component: resolve => require(['@/components/report/coupons/index/index.vue'], resolve)
    },
    {
      path: '/report/coupons_target_trend',
      name: 'coupons_target_trend',
      component: resolve => require(['@/components/report/coupons/trend/index.vue'], resolve)
    },
    {
      path: '/report/coupons_detail',
      name: 'coupons_detail',
      component: resolve => require(['@/components/report/coupons/detail/index.vue'], resolve)
    },
    {
      path: '/report/coupons_change',
      name: 'coupons_change',
      component: resolve => require(['@/components/report/coupons/change/index.vue'], resolve)
    },
    {
      path: '/report/coupons_save',
      name: 'coupons_save',
      component: resolve => require(['@/components/report/coupons/save/index.vue'], resolve)
    },
    // 积分分析
    {
      path: '/report/integral_index',
      name: 'integral_index',
      component: resolve => require(['@/components/report/integral/index/survery.vue'], resolve)
    },
    {
      path: '/report/integral_target_trend',
      name: 'integral_target_trend',
      component: resolve => require(['@/components/report/integral/trend/index.vue'], resolve)
    },
    {
      path: '/report/integral_analysis',
      name: 'integral_analysis',
      component: resolve => require(['@/components/report/integral/analysis/index.vue'], resolve)
    },
    {
      path: '/report/integral_goods',
      name: 'integral_goods',
      component: resolve => require(['@/components/report/integral/goods/index.vue'], resolve)
    },
    // 要加 会员体系 LE-4538
    // 会员等级概况
    {
      path: '/report/member_level_overview',
      name: 'member_level_overview',
      component: resolve => require(['@/components/report/member_level/overview/index.vue'], resolve)
    },
    // 会员等级趋势  参考 积分趋势
    {
      path: '/report/member_level_trend',
      name: 'member_level_trend',
      component: resolve => require(['@/components/report/member_level/trend/index.vue'], resolve)
    },
    // 会员等级增长  参考 积分增长
    {
      path: '/report/member_level_growth',
      name: 'member_level_growth',
      component: resolve => require(['@/components/report/member_level/growth/index.vue'], resolve)
    },
    // 复制三个页面
    {
      path: '/report/cust_consumption_overview_copy',
      name: 'cust_consumption_overview_copy',
      component: resolve => require(['@/components/report/customerConsumption/overview/indexCopy.vue'], resolve)
    },
    {
      path: '/report/cust_consumption_trends_copy',
      name: 'cust_consumption_trends_copy',
      component: resolve => require(['@/components/report/customerConsumption/trends/indexCopy.vue'], resolve)
    },
    {
      path: '/report/cust_consumption_growth_copy',
      name: 'cust_consumption_growth_copy',
      component: resolve => require(['@/components/report/customerConsumption/growth/indexCopy.vue'], resolve)
    },
  ]
}

export default marketRouter
